import React, { useState, useEffect, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { getAllUsers, useGetAllUsers, deleteUser } from "../Utils/User";
import { useGetDriversForFleets } from "../Utils/Fleet";
import Table from "../Base/Table";
import styled from "styled-components";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const Input = styled.input`
  padding: 10px;
  font-size: 14px;
  margin-bottom: 10px;
  width: 305px;
  padding: 12px 20px;
`;

/**
 * User Table Component
 */
const UserTable = ({
  companyId,
  fleetId,
  title,
  userRole,
  limit,
  hideEnergy,
  hideFilter,
  hideRole,
  hideCompany,
  hideDelete,
  driverTable,
  fleets
}) => {
  const { users, loading: loadingUsers } = useGetAllUsers(companyId, fleetId, userRole);
  const [filter, setFilter] = useState("");

  const { drivers } = useGetDriversForFleets(fleets);

  var columns = [
    {
      Header: "Name",
      accessor: "fullName",
      headerClassName: "left",
      minWidth: 200,
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        return <NavLink to={`/user/${original.uid}`}>{original.fullName}</NavLink>;
      }
    }
  ];
  if (!hideRole)
    columns.push({
      Header: "Role",
      headerClassName: "left",
      accessor: "role"
    });

  if (!hideCompany)
    columns.push({
      Header: "Company",
      className: "left",
      headerClassName: "left",
      accessor: "companyName"
    });

  if (driverTable)
    columns.push({
      Header: "Fleet",
      className: "left",
      headerClassName: "left",
      accessor: "fleetName"
    });

  if (!hideEnergy)
    columns.push({
      Header: hideEnergy ? "" : "Energy",
      className: "center",
      accessor: "energyLevel",
      sortMethod: (a, b) => {
        if (isNaN(a) && !isNaN(b)) return 1;
        else if (isNaN(b) && !isNaN(a)) return -1;
        else if (a === b) return 0;
        else return a < b ? 1 : -1;
      }
    });

  if (!hideDelete)
    columns.push({
      Header: "",
      sortable: false,
      className: "center",
      Cell: props => {
        // eslint-disable-next-line react/prop-types
        const { original } = props;
        return (
          <button
            type="button"
            onClick={() => {
              confirmAlert({
                title: "Confirm Deletion",
                message: "Are you sure you want to delete this user?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () =>
                      deleteUser({ uid: original.uid }).then(() => toast("User Deleted", { type: toast.TYPE.INFO }))
                  },
                  {
                    label: "No"
                  }
                ]
              });
            }}
          >
            Delete
          </button>
        );
      }
    });

  var filteredData = filter ? users.filter(d => d.fullName.toLowerCase().includes(filter.toLowerCase())) : users;
  if (userRole === "managers")
    filteredData = filteredData.filter(d => {
      if (d.role) return d.role.includes("manager") || d.role === "super";
    });
  if (fleets)
    filteredData = filter ? drivers.filter(d => d.fullName.toLowerCase().includes(filter.toLowerCase())) : drivers;

  console.log("filteredData");
  return (
    <Fragment>
      {title && <h2>{title}</h2>}
      {!hideFilter && (
        <form>
          <Input
            type="text"
            name="filter"
            id="filter"
            placeholder="Filter by Name"
            onChange={event => {
              setFilter(event.target.value);
            }}
            value={filter}
          />
        </form>
      )}
      <Table
        data={loadingUsers ? [] : filteredData}
        columns={columns}
        pageSize={!loadingUsers && (limit <= filteredData.length ? limit : filteredData.length)}
      />
    </Fragment>
  );
};

export default UserTable;
